import { Injectable } from '@angular/core';

import { passageirosRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute, configuracaoRoute } from "../../../shared/services/data.service";
import { viagensRoute } from "../../shared/data.service";

@Injectable()
export class PassageiroNavigationService {
    moduleRouter: string = passageirosRoute;
    fatherRouter: string = viagensRoute;
    configuracaoRouter: string = configuracaoRoute;

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = this.fatherRouter + '/' + this.configuracaoRouter + '/' + this.moduleRouter;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = this.fatherRouter + '/' + this.configuracaoRouter + '/' + this.moduleRouter + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = this.fatherRouter + '/' + this.configuracaoRouter + '/' + this.moduleRouter + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/shared/passageiro-navigation.service.ts
 **/